
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 7.222v9a3 3 0 01-3 3H3a3 3 0 01-3-3v-9c0-1.11.603-2.08 1.5-2.598l-.003-.004L9.498 0l8.007 4.623-.001.003A2.999 2.999 0 0119 7.222zM1.717 5.688L9.5 10.742l7.783-5.054-7.785-4.533-7.781 4.533zM9.5 11.934L1.134 6.502c-.089.23-.134.474-.134.72v9a2 2 0 002 2h13a2 2 0 002-2v-9c0-.254-.047-.497-.134-.72L9.5 11.933v.001z","fill":"#000"}})])
          )
        }
      }
    